export const EventData = [
    {
        eventname: 'Yoga Session',
        eventdesctiption: 'Description of Event',
        eventlocation: 'Location of Event',
        eventdate: 'Date of Event',
        eventime: 'Time of Event',
        eventduration: 2,
        lastenrollment: 'Last Enrollment Date',
        eventcost: 'Cost of Event',
    },
    {
        eventname: 'Short Picnic',
        eventdesctiption: 'Description of Event',
        eventlocation: 'Location of Event',
        eventdate: 'Date of Event',
        eventime: 'Time of Event',
        eventduration: 3,
        lastenrollment: 'Last Enrollment Date',
        eventcost: 'Cost of Event',
    },
    {
        eventname: 'Temple Visit',
        eventdesctiption: 'Description of Event',
        eventlocation: 'Location of Event',
        eventdate: 'Date of Event',
        eventime: 'Time of Event',
        eventduration: 4,
        lastenrollment: 'Last Enrollment Date',
        eventcost: 'Cost of Event',
    },
    {
        eventname: 'Laughing Club',
        eventdesctiption: 'Description of Event',
        eventlocation: 'Location of Event',
        eventdate: 'Date of Event',
        eventime: 'Time of Event',
        eventduration: 2,
        lastenrollment: 'Last Enrollment Date',
        eventcost: 'Cost of Event',
    },

];

export default EventData;